import React from "react";
import { useNavigate } from "react-router-dom";
import "./Header.css";

function Header() {
    const navigate = useNavigate();

    const handleLogout = () => {
        localStorage.removeItem("accessToken");
        navigate("/login");
    };

    return (
        <header className="top-header">
            <div className="left-section">
                <h2>First Outcomes</h2>
            </div>

            <div className="right-section">
                <button className="logout-btn" onClick={handleLogout}>
                    <span style={{ marginRight: 8 }}>🚪</span>
                    Logout
                </button>
            </div>
        </header>
    );
}

export default Header;
